module.exports = __webpack_public_path__ + "img/bttn_eliz_map.e513fd3d.png";